/** Resolve hasActivePlan from a dashboard-v3 API / thunk payload. */
export function resolveEmployerHasActivePlan(payload) {
  if (payload == null) return false;

  const candidates = [
    payload?.data?.[0],
    payload?.data,
    payload?.empDashDataV3?.data?.[0],
    payload?.empDashDataV3?.data,
    payload?.user?.data?.[0],
    payload?.user?.data,
  ];

  for (const item of candidates) {
    if (item && typeof item === "object" && !Array.isArray(item)) {
      if (typeof item.hasActivePlan === "boolean") {
        return item.hasActivePlan;
      }
    }
  }

  return false;
}
